import appleTrust from "@assets/app_store_app_of_the_day_2023_white.webp"
import appleLogo from "@assets/applestore.webp"
import googleTrust from "@assets/google_editors_choice_2023_white.webp"
import googleLogo from "@assets/googleplaystore.webp"
import StarRating from "@components/StarRating"
import StoreRating from "@components/StoreRating"
import TestimonialCard from "@components/TestimonialCard"
import { getOnboardingContext, isHomeFlow } from "@helpers/localStorage"
import { useTranslation } from "react-i18next"

const TESTIMONIAL_OPTIONS = [1, 2, 3] as const

const STORE_OPTIONS = [
  {
    logo: appleLogo,
    logoAlt: "App Store",
    ratingKey: "pages.checkout.trust_element.appStoreRating",
    ratingsCountKey: "pages.checkout.trust_element.appStoreRatingsCount",
    colorClass: "text-blue-600",
  },
  {
    logo: googleLogo,
    logoAlt: "Google Play",
    ratingKey: "pages.checkout.trust_element.googlePlayRating",
    ratingsCountKey: "pages.checkout.trust_element.googlePlayRatingsCount",
    colorClass: "text-green-600",
  },
] as const

const BADGE_OPTIONS = [
  { src: appleTrust, alt: "App Store App of the Day 2023" },
  { src: googleTrust, alt: "Google Editors' Choice 2023" },
] as const

export default function Trust() {
  const { t } = useTranslation()
  const context = getOnboardingContext()
  const trustCopyKey =
    context === "cars"
      ? "pages.checkout.trust_element_cars"
      : context === "pets"
        ? "pages.checkout.trust_element_pets"
        : isHomeFlow()
          ? "pages.checkout.trust_element_home"
          : "pages.checkout.trust_element"

  return (
    <div className="space-y-8 text-center">
      {/* Testimonials Section */}
      <div className="space-y-4">
        <h2 className="heading">{t(`${trustCopyKey}.testimonialsHeading`)}</h2>

        <div className="grid gap-4 md:grid-cols-3">
          {TESTIMONIAL_OPTIONS.map((num) => (
            <TestimonialCard
              key={num}
              text={t(`${trustCopyKey}.testimonial${num}`)}
              author={t(`${trustCopyKey}.testimonial${num}Author`)}
            />
          ))}
        </div>
      </div>

      {/* Store Ratings Section */}
      <div className="grid grid-cols-2 gap-4">
        {STORE_OPTIONS.map((store) => (
          <StoreRating
            key={store.logoAlt}
            logo={store.logo}
            logoAlt={store.logoAlt}
            rating={t(store.ratingKey)}
            ratingsCount={t(store.ratingsCountKey)}
            colorClass={store.colorClass}
          />
        ))}
      </div>

      {/* Company Awards Section */}
      <div className="space-y-4">
        <h2 className="heading">{t("pages.checkout.trust_element.heading")}</h2>

        <div className="flex items-center justify-center gap-4">
          {BADGE_OPTIONS.map((badge) => (
            <img
              key={badge.alt}
              src={badge.src}
              alt={badge.alt}
              className="w-36"
            />
          ))}
        </div>

        <p className="text-text-secondary text-base">
          {t(`${trustCopyKey}.andHas`)}
        </p>

        <p className="text-2xl font-semibold">
          {t(`${trustCopyKey}.userAmount`)}
        </p>

        <div className="flex justify-center">
          <StarRating rating={5} />
        </div>
      </div>
    </div>
  )
}
